import defaultContent from '@/data/userTestContent.js';

import { getMaxRectInBounds } from '@/util/bounds.js';

import resizeStyles from '@/components/Resize/Resize.module.css';

let idCounter = 100;
const getNewId = () => idCounter++;

/*
    When the selection changes, modify the z order
*/
const getSortedMedia = function(media, selection, action) {
    let sortedMedia = media;

    const mediaCopy = media.concat();
    
    switch (action.type) {
        case 'SET_SELECTION': {
            if (selection.length == 0) {
                sortedMedia = mediaCopy;
                break;
            }
        }
        case 'ADD_SELECTION':
        {
            sortedMedia = mediaCopy
            .sort(
            (a,b) => {
                if (action.selection.indexOf(a.id) !== -1) {
                    return 1;
                } else if (action.selection.indexOf(b.id) !== -1) {
                    return -1;
                }
                return 0;
            }
            );
            break;
        }

        case 'REMOVE_SELECTION': {
            sortedMedia = mediaCopy
            .sort(
                (a,b) => {
                    if (action.selection.indexOf(a.id) !== -1) {
                        if (selection.indexOf(b.id) > -1) {
                            return -1;
                        }
                    } else if (action.selection.indexOf(b.id) !== -1) {
                        if (selection.indexOf(a.id) > -1) {
                            return 1;
                        }
                    }
                    return 0;
                }
            );
            break;
        }
    }
    
    return sortedMedia;
}

const contentReducer = function(state = {media: defaultContent, active: [], selection: [], hover: []}, action)
{
    let media = state.media;
    let active = state.active;
    let selection = state.selection;
    let hover = state.hover;

    switch (action.type) {
        /*
        selection-centric actions
        */
        case 'SET_SELECTION': {
            if (!!action.selection) {
                selection = action.selection;
            } else {
                selection = [];
            }

            media = getSortedMedia(media, selection, action)
            .map(function(item){
                item.editing = false;
                return item;
            });

            break;
        }

        case 'ADD_SELECTION': {
            action.selection.forEach((item) => {
                if (selection.indexOf(item) == -1) {
                    selection = selection.concat(item);
                }
            })

            media = getSortedMedia(media, selection, action);
            break;
        }

        case 'REMOVE_SELECTION': {
            const editedSelection = selection.concat();

            action.selection.forEach((item) => {
                const index = editedSelection.indexOf(item);
                if (index !== -1) {
                    editedSelection.splice(index, 1);
                }
            })

            selection = editedSelection;
            media = getSortedMedia(media, selection, action);
            break;
        }

        // case 'RESET_SELECTION': {
        //     selection = null;
        //     break;
        // }

        /*
        activation-centric actions
        */
        case 'SET_ACTIVE': {
            if (!!action.active) {
                active = action.active;
            } else {
                active = [];
            }

            break;
        }
        case 'SET_CONTENT_ACTIVE': {

            if (action.active) {
                if (active.indexOf(action.id) == -1) {
                    active = active.concat(action.id);
                }
            } else {
                const index = active.indexOf(action.id);
                if (index !== -1) {
                    active.splice(index, 1);
                }
            }

            break;

        }



        /*
        media-centric actions
        */
        case 'ADD_NOTECARD': {
            const editedContent = media
            .concat();

            const id = 'txt' + (getNewId());

            editedContent.push({                
                id: id,
                background: "#CCCCCC",
                fg_color: "#CCCCCC",
        
                type: 'text',
                content: '',
        
                width: action.w,
                height: action.h,
        
                x: action.x,
                y: action.y,
                scale: 1
            })

            media = editedContent;

            if (true) {
                active = active.concat(id);
            }

            selection = [id];

            media = getSortedMedia(media, selection, action)
            .map(function(item){
                item.editing = false;
                return item;
            });

            break;
        }


        case 'EDIT_SELECTED': {
            const editedContent = media.concat().map(function(item){
                item.editing = false;
                return item;
            });

            selection.map(function(selected_item){
                media.filter(function(media_item){
                    return media_item.id === selected_item;
                })
                .map(function(media_item){
                    media_item.editing = true;
                })
            });
            media = editedContent;
            break;
        }

        case 'SET_CONTENT_SIZE': {
            // console.log('action', action);
            // let media_item_update = {};
            media = media.map(function(media_item){
                if (action.id !== media_item.id) {
                    return media_item;
                } else {
                    const media_item_update = {
                        width: action.width,
                        height: action.height
                    };
                    return Object.assign(
                        {},
                        media_item,
                        media_item_update
                    )
                }
            })

            break;
        }

        case 'SCALE_UP': {
            // console.log('action', action);
            // let media_item_update = {};
            media = media.map(function(media_item){
                if (action.id !== media_item.id) {
                    return media_item;
                } else {
                    const media_item_update = {
                        scale: media_item.scale * 1.1
                    };
                    return Object.assign(
                        {},
                        media_item,
                        media_item_update
                    )
                }
            })

            break;
        }

        case 'SCALE_DOWN': {
            // console.log('action', action);
            // let media_item_update = {};
            media = media.map(function(media_item){
                if (action.id !== media_item.id) {
                    return media_item;
                } else {
                    const media_item_update = {
                        scale: media_item.scale / 1.25
                    };
                    return Object.assign(
                        {},
                        media_item,
                        media_item_update
                    )
                }
            })

            break;
        }

        case 'SET_SCALE': {
            // console.log('action', action);
            // let media_item_update = {};
            media = media.map(function(media_item){
                if (action.id !== media_item.id) {
                    return media_item;
                } else {
                    const media_item_update = {
                        scale: action.scale // media_item.scale / xxx
                    };
                    return Object.assign(
                        {},
                        media_item,
                        media_item_update
                    )
                }
            })

            break;
        }



        case 'RESIZE_SELECTION_BY': {

            console.log('RESIZE:', action);
            // const editedContent = media.concat();            

            const bounds = action.bounds;
            const w = bounds.maxX - bounds.minX;
            const h = bounds.maxY - bounds.minY;

            // console.log('a', action);

            media = media.map(function(media_item){
                if (selection.indexOf(media_item.id) == -1) {
                    return media_item;
                } else {

                    const media_item_update = {};

                    let xPositionCoeff = 0, yPositionCoeff = 0;

                    switch (action.handle) {
                        case resizeStyles.w:
                            xPositionCoeff = 1;
                            yPositionCoeff = 0.5;
                            break;
                        case resizeStyles.e:
                            yPositionCoeff = 0.5;
                            break;
                        case resizeStyles.nw:
                            xPositionCoeff = 1;
                            yPositionCoeff = 1;
                            break;
                        case resizeStyles.n:
                            xPositionCoeff = 0.5;
                            yPositionCoeff = 1;
                            break;
                        case resizeStyles.ne:
                            yPositionCoeff = 1;
                            break;
                        case resizeStyles.sw:
                            xPositionCoeff = 1;
                            break;
                        case resizeStyles.s:
                            xPositionCoeff = 0.5;
                            break;
                        case resizeStyles.se:

                        default:
                            break;
                    }

                    const useFitToBoundingBox = true;
                    // console.log('action.aspectLock', action.aspectLock);
                    const newBoundingBox = (action.aspectLock) ? (getMaxRectInBounds(w, h, action.targetBounds.width, action.targetBounds.height)) : action.targetBounds;

                    const new_x = bounds.minX - xPositionCoeff * (newBoundingBox.width - w);
                    const new_y = bounds.minY - yPositionCoeff * (newBoundingBox.height - h);
                    // console.log('?', newBoundingBox)

                    if (Math.abs(media_item.width - w) < 0.001) {
                        media_item_update.x = new_x;
                        media_item_update.width = newBoundingBox.width;
                    } else {
                        media_item_update.width = media_item.width/w * newBoundingBox.width;
                        media_item_update.x = new_x + ((media_item.x - bounds.minX) / w * newBoundingBox.width);
                    }


                    if (Math.abs(media_item.height - h) < 0.001) {
                        media_item_update.y = new_y;
                        media_item_update.height = newBoundingBox.height;  
                    } else {
                        media_item_update.height = media_item.height/h * newBoundingBox.height;
                        media_item_update.y = new_y + ((media_item.y - bounds.minY) / h * newBoundingBox.height);
                    }

                    media_item_update.width = Math.max(w/h, media_item_update.width);
                    media_item_update.height = Math.max(1, media_item_update.height);

                    if (media_item_update.width > w + action.dWidth 
                        || media_item_update.height > h + action.dHeight) {
                            console.log(action, media_item, media_item_update);
                            console.log(media_item_update.width - (w + action.dWidth),  media_item_update.height - (h + action.dHeight))
                    }

                    // console.log('media_item', media_item, 'media_item_update', media_item_update, media_item.height/media_item.width, media_item_update.height/media_item_update.width)

                    return Object.assign(
                        {},
                        media_item,
                        media_item_update
                    )
                }
            })



            break;
        }
        case 'MOVE_SELECTION_BY': {
            // const editedContent = media.concat();

            // selection.map(function(selected_item){
            //     media.filter(function(media_item){
            //         return media_item.id === selected_item;
            //     })
            //     .map(function(media_item){


            //         // media_item.x += action.dx;
            //         // media_item.y += action.dy;    
            //     })
            // });

            media = media.map(function(media_item){
                if (selection.indexOf(media_item.id) == -1) {
                    return media_item;
                } else {
                    return Object.assign(
                        {},
                        media_item,
                        {
                            x: media_item.x + action.dx,
                            y: media_item.y + action.dy
                        }
                    )
                }
            })



            // media = editedContent;
            break;
        }






        case 'SET_HOVER': {
            if (!!action.hover) {
                hover = action.hover;
            } else {
                hover = [];
            }
            break;
        }

        // case 'SET_CONTENT': {
        // }
        // case 'ADD_CONTENT': {
        // }
        // case 'REMOVE_CONTENT': {
        // }

        // case 'RESET_CONTENT': {
        //     media = null;
        //     break;
        // }

        default: {
            // console.log('ZOOM DEFAULT');
            return state;
        }
    }

    return {
        media,
        active,
        selection,
        hover
    }
};

export default contentReducer;